export default __webpack_public_path__ + "static/media/Paw.dc49fad7.svg";